export default __webpack_public_path__ + "static/media/DSC_7372.e7d6f939.jpg";